import React from 'react';

export default function KountStatus({ decision, message }) {
	const statusClass = decision === 'ALLOW' ? 'status-allow'
		: decision === 'BLOCK' ? 'status-block'
		: 'status-challenge';

	return (
		<div className={`kount-status ${statusClass}`}>
			<h3>Kount Decision: {decision}</h3>
			{decision === 'ALLOW' && (
				<p>Identity verified. Proceeding to credit check...</p>
			)}
			{decision === 'BLOCK' && (
				<p>This request has been blocked by fraud prevention. Cannot proceed with credit check.</p>
			)}
			{decision === 'CHALLENGE' && (
				<p>Additional verification required. An OTP has been sent to the contact's mobile number.</p>
			)}
			{message && <p className="detail">{message}</p>}
		</div>
	);
}
